import { render, staticRenderFns } from "./ExtraKeyboardKey.vue?vue&type=template&id=60230567&scoped=true&"
import script from "./ExtraKeyboardKey.vue?vue&type=script&lang=ts&"
export * from "./ExtraKeyboardKey.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraKeyboardKey.vue?vue&type=style&index=0&id=60230567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60230567",
  null
  
)

export default component.exports